<template>
  <VTooltip theme="info-tooltip">
    <span
      :class="[badgeClasses, clickable ? 'cursor-pointer' : '']"
      class="inline-flex items-center gap-1 rounded-full px-2 py-0.5"
      @click="clickable && $emit('click')"
    >
      <SparklesIcon class="h-3 w-3 shrink-0" :class="sparklesColorClass" />
      <component :is="statusIcon" class="h-3.5 w-3.5 shrink-0" :class="iconColorClass" />
    </span>
    <template #popper>
      <span>{{ tooltip }}</span>
    </template>
  </VTooltip>
</template>

<script>
import {
  SparklesIcon,
  CheckCircleIcon,
  ExclamationIcon,
  XCircleIcon,
  ClockIcon,
  ExclamationCircleIcon,
} from "@heroicons/vue/solid";

const VERDICT_CONFIG = {
  PASS: {
    icon: "CheckCircleIcon",
    badge: "bg-green-50 border border-green-200",
    icon_color: "text-green-600",
    sparkles_color: "text-green-400",
  },
  REVIEW: {
    icon: "ExclamationIcon",
    badge: "bg-yellow-50 border border-yellow-200",
    icon_color: "text-yellow-600",
    sparkles_color: "text-yellow-400",
  },
  FAIL: {
    icon: "XCircleIcon",
    badge: "bg-red-50 border border-red-200",
    icon_color: "text-red-600",
    sparkles_color: "text-red-400",
  },
  error: {
    icon: "ExclamationCircleIcon",
    badge: "bg-red-50 border border-red-200",
    icon_color: "text-red-600",
    sparkles_color: "text-red-400",
  },
  pending: {
    icon: "ClockIcon",
    badge: "bg-gray-50 border border-gray-200",
    icon_color: "text-gray-400",
    sparkles_color: "text-gray-300",
  },
};

export default {
  name: "DocumentAnalysisBadge",

  components: {
    SparklesIcon,
    CheckCircleIcon,
    ExclamationIcon,
    XCircleIcon,
    ClockIcon,
    ExclamationCircleIcon,
  },

  props: {
    verdict: {
      type: String,
      default: null,
    },
    isAnalyzed: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["click"],

  computed: {
    config() {
      if (this.hasError) return VERDICT_CONFIG.error;
      if (!this.isAnalyzed) return VERDICT_CONFIG.pending;
      return VERDICT_CONFIG[this.verdict] || VERDICT_CONFIG.pending;
    },
    statusIcon() {
      return this.config.icon;
    },
    badgeClasses() {
      return this.config.badge;
    },
    iconColorClass() {
      return this.config.icon_color;
    },
    sparklesColorClass() {
      return this.config.sparkles_color;
    },
  },
};
</script>
